// extracted by mini-css-extract-plugin
export default {"root":"privacy-statement_root__h4Eep","subHeader":"privacy-statement_subHeader__xe50B","list":"privacy-statement_list__qZOEa"};